import { Box } from "@mui/material";
import { ContentPreview } from "../../modules/content-previews/content-preview";
import { UpdateImageryButton } from "../../modules/content-previews/update-imagery-button";

import type { MultiformatConfig } from "../../modules/multiformat/store/types";
import type { FC } from "react";

export const PreviewsSkeletons: FC<{
  multiformatConfig: MultiformatConfig;
}> = ({ multiformatConfig }) => (
  <>
    {multiformatConfig.layouts.some((l) => l.images.some((i) => i.type)) && (
      <UpdateImageryButton disabled onOpen={() => {}} onClose={() => {}} />
    )}
    <Box
      sx={[
        (theme) => ({
          display: "grid",
          gap: 2,
          [theme.breakpoints.down("xs")]: {
            gridTemplateColumns: "1fr",
          },
          [theme.breakpoints.up("sm")]: {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
          [theme.breakpoints.up("lg")]: {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
        }),
      ]}
    >
      {Array.from({ length: 4 }).map((_, i) => (
        <ContentPreview
          // oxlint-disable-next-line react/no-array-index-key -- Skeleton placeholders have no identity
          key={i}
          image={{ state: "loading" }}
          hidden={false}
          dimensions={multiformatConfig.design_huddle!.dimensions!}
        />
      ))}
    </Box>
  </>
);
